import React, { useState } from 'react';
import GetCSRFToken from "../components/atoms/getCSRFToken";

/**
 * Geting input field for CSRF token
 *
 * @param name - name of varialbe
 * @param register - register controlled inputs
 * @param setValue - setValue
 */
export const useCsrfToken = (name, register, setValue) => {
  const [ isLoading, setIsLoading ] = useState(false);
  const [ csrfToken, setCSRFToken ] = useState('');

  if (csrfToken === '' && !isLoading) {
    setIsLoading(true);

    GetCSRFToken(name).then(
      csrfToken => {
        setValue('csrf_token', csrfToken, {shouldDirty: false});
        setCSRFToken(csrfToken);
      }
    ).finally(() => {
      setIsLoading(false);
    });
  }

  const csrfTokenComponent = (
    <input
      type="hidden"
      {...register("csrf_token", {value: csrfToken})}
    />
  );

  return { csrfTokenComponent };
};
